module.exports = __webpack_public_path__ + "static/loyalty.f3860ddc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/loyalty.jpg
// module id = 273
// module chunks = 35783957827783 112904724367323